import tw from "tailwind-styled-components";
import type { CSSObjectWithLabel } from "react-select";

export const ListContainer = tw.div`
max-w-7xl w-full h-full 
flex flex-col p-5 gap-5 relative
`;

export const NavbarListContainer = tw.div`
flex items-center justify-between
`;

export const Path = tw.div`
font-Roboto font-semibold 
text-sm text-gray-400
`;

export const Container1 = tw.div`
flex flex-col gap-3
`;

export const NavbarTitle = tw.h1`
font-bold text-[#0052A2] text-xl
`;

export const ExcelButtonsContainer = tw.div`
flex gap-3 items-center ml-10
`;

export const SelectContainer = tw.div`
flex mr-10 items-center
`;

export const LoadingMsg = tw.span`
font-Roboto text-sm text-gray-500
mr-4 
`;

export const LoaderContainer = tw.div`
flex mr-8
`;

export const TableContainer = tw.div`
w-full pb-5 overflow-auto
`;

export const SelectStyles = () => ({
  control: (provided: CSSObjectWithLabel) => ({
    ...provided,
    cursor: "pointer",
    width: "350px",
    border: "2px solid #DFE5EF",
    borderRadius: "0.5rem",
    boxShadow: "none",
    fontFamily: "Outfit",
    fontSize: "15px",
    "&:hover": {
      borderColor: "#1C93FF",
    },
    "&:focus": {
      borderColor: "#1C93FF",
    },
  }),
  option: (provided: CSSObjectWithLabel, data: any) => ({
    ...provided,
    cursor: "pointer",
    fontFamily: "Outfit",
    fontSize: "15px",
    color: "#0C0A09",
    backgroundColor: data.isFocused ? "#F3F4F6" : null,
  }),
});
export const ButtonsContainer = tw.div`
flex gap-5 items-center
`;
